import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=d8b1fc3e&scoped=true&"
import script from "./Discount.vue?vue&type=script&lang=js&"
export * from "./Discount.vue?vue&type=script&lang=js&"
import style0 from "./Discount.vue?vue&type=style&index=0&id=d8b1fc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b1fc3e",
  null
  
)

export default component.exports